
import SearchAutocomplete from '../autocomplete';
import SearchFilters from '../filters';
import SearchFiltersActions from '../filters/actions';
import SearchTopPanelSection from './section';
import Divider from '@/ui-kit/components/divider';
import Gutter from '@/ui-kit/components/gutter';
import {
  StyleSizeType,
  StyleColorSchemeType,
  StylePositionType,
  StyleOrientationType,
} from '@/ui-kit/styles/enums';

export default {
  name: 'SearchTopPanel',
  components: {
    SearchTopPanelSection,
    SearchFiltersActions,
    Gutter,
    Divider,
    SearchFilters,
    SearchAutocomplete,
  },
  props: {
    filters: {
      default: () => ({}),
      type: Object,
    },
    filtersSubmitButtonLabel: {
      default: '',
      type: String,
    },
    filtersResetButtonLabel: {
      default: '',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    autocompleteLoading: {
      default: false,
      type: Boolean,
    },
    autocompleteValue: {
      default: '',
      type: String,
    },
    autocompleteOptions: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      StyleSizeType,
      StylePositionType,
      StyleColorSchemeType,
      StyleOrientationType,
    };
  },
  methods: {
    handleFiltersChange(value) {
      this.$emit('filters-change', value);
    },
    handleFiltersReset() {
      this.$emit('filters-reset');
    },
    handleFiltersSubmit() {
      this.$emit('filters-submit');
    },
    handleAutocompleteChange(value) {
      this.$emit('autocomplete-change', value);
    },
    handleAutocompleteSelect(value) {
      this.$emit('autocomplete-select', value);
    },
  },
};
